module.exports = __webpack_public_path__ + "static/media/AIcollage1.36c07f64.webp";